<template>
    <div class="temp-content-action">
      <t-form>
          <!--基础信息-->
          <div class="base-info-wrap">
              <div class="section-title">基础信息</div>

              <!--营地名称-->
              <div class="form-item">
                  <div class="form-item-title">
                      <span class="require-symbol">*</span>
                      营地名称
                  </div>

                  <div class="form-element">
                      <t-input
                          v-model="formData.name"
                          placeholder="请输入营地名称"
                          :maxlength="32"
                          show-limit-number
                          clearable
                          size="large"
                      />
                  </div>
              </div>
              
              <!--营地类型-->
              <div class="form-item">
                  <div class="form-item-title">
                      <span class="require-symbol">*</span>
                      营地类型
                  </div>
                  <div class="form-element">
                      <t-select
                        v-model="formData.campType"
                        :options="campTypeOption"
                        filterable
                        multiple
                        clearable
                        placeholder="请选择营地类型"
                        size="large"
                      />
                  </div>
              </div>

              <!--营地位置-->
              <div class="form-item">
                  <div class="form-item-title">
                      <span class="require-symbol">*</span>
                      营地位置
                  </div>

                  <div class="form-element">
                      <t-input
                        v-model="formData.location"
                        placeholder="请输入经纬度"
                        show-limit-number
                        clearable
                        size="large"
                      />

                      <div class="tip-desc" >
                          请复制坐标后填入（示例：116.76,39.87）
                          <div class="tip-desc-url" @click="openMapPicker">
                            复制坐标
                          </div>
                      </div>
                  </div>
              </div>


              <!--开放日期-->
              <div class="form-item">
                  <div class="form-item-title">
                      <span class="require-symbol">*</span>
                      开放日期
                  </div>
                  <div class="form-element">
                      <t-select
                        v-model="formData.openDate"
                        :options="openDateOption"
                        filterable
                        multiple
                        clearable
                        placeholder="请选择日期"
                        size="large"
                      />
                  </div>
              </div>
              
              <!--营业时间-->
              <div class="form-item">
                  <div class="form-item-title">
                    <span class="require-symbol">*</span>
                      营业时间
                  </div>

                  <div class="form-element">
                      <t-time-range-picker
                        v-model="formData.openTime"
                        format="HH:mm"
                        allowInput
                        clearable
                        size="large"
                      />
                  </div>
              </div>

              <!--营地价格-->
              <div class="form-item">
                  <div class="form-item-title">
                      <span class="require-symbol">*</span>
                      营地价格
                  </div>

                  <div class="form-element">
                      <t-input
                        v-model="formData.price"
                        type="number"
                        placeholder="请输入价格"
                        suffix="元"
                        clearable
                        size="large"
                      />

                      <div class="form-add">
                          <t-textarea
                            v-model="formData.priceDesc"
                            placeholder="请输入价格说明"
                            :maxlength="descMaxLength"
                            show-limit-number
                            clearable
                            size="large"
                          />
                      </div>
                  </div>

                  
              </div>

              <!--联系电话-->
              <div class="form-item">
                  <div class="form-item-title">
                      联系电话
                  </div>

                  <div class="form-element">
                      <t-input
                          v-model="formData.phone"
                          placeholder="请输入联系电话"
                          :maxlength="16"
                          show-limit-number
                          clearable
                          size="large"
                      />
                  </div>
              </div>

              <!--实地认证-->
              <div class="form-item">
                      <div class="form-item-title">实地认证</div>
                      <div class="form-element">
                              <t-radio-group
                                  class="radio-group"
                                  v-model="formData.isOnSite"
                              >
                                  <t-radio :value="true">是</t-radio>
                                  <t-radio :value="false">否</t-radio>
                              </t-radio-group>                  
                      </div>
              </div>  

              <!--营地标签-->
              <div class="form-item">
                  <div class="form-item-title"> 营地标签</div>
                  <!--营地标签选项-->
                  <div class="form-element">
                      <t-checkbox-group v-model="formData.campTag" size="large">
                          <t-checkbox v-for="tag in campTag" :key="tag.value" :value="tag.value">
                              {{ tag.label }}
                          </t-checkbox>
                      </t-checkbox-group>
                  </div>
              </div>
          </div>
        
          <!--营地图片信息-->
          <div class="camp-image-info-wrap">
              <div class="section-title">
                  营地图片信息
              </div>

              <div class="form-item">
                  <div class="form-item-title">
                      <span class="require-symbol">*</span>
                      上传图片
                  </div>
                  <div>
                      <t-upload
                          v-model="formData.image"
                          theme="image"
                          accept="image/*"
                          :auto-upload="false"
                          :showImageFileName="false"
                          multiple
                          :max="30"
                          :size-limit="sizeLimit"
                          tips="第1张图片为主图，最大不超过10M，最多上传30张"
                          @success="onUploadSuccess"
                          @fail="onUploadFail"
                          :beforeUpload="beforeUpload"
                      >
                      </t-upload>
                  </div>
              </div>
          </div>

          <!--营地评分信息-->
          <div class="camp-tag-wrap">
              <div class="section-title">营地评分信息</div>

              <!--营地环境评分-->
              <div class="form-item">
                  <div class="form-item-title">
                      <span class="require-symbol">*</span>
                      营地环境
                  </div>

                  <div class="form-element">
                      <t-input
                        v-model="formData.envRate"
                        type="number"
                        placeholder="请输入营地环境评分"
                        suffix="分"
                        clearable
                        size="large"
                      />
                  </div>

                  
              </div>

              <!--营地设施评分-->
              <div class="form-item">
                  <div class="form-item-title">
                      <span class="require-symbol">*</span>
                      营地设施
                  </div>

                  <div class="form-element">
                      <t-input
                        v-model="formData.facilityRate"
                        type="number"
                        placeholder="请输入营地设施评分"                   
                        suffix="分"
                        clearable
                        size="large"
                      />
                  </div> 
              </div>

              <!--营地体验评分-->
              <div class="form-item">
                  <div class="form-item-title">
                      <span class="require-symbol">*</span>
                      营地体验
                  </div>

                  <div class="form-element">
                      <t-input
                        v-model="formData.experienceRate"
                        type="number"
                        placeholder="请输入营地体验评分"
                        suffix="分"
                        clearable
                        size="large"
                      />
                  </div> 
              </div>

              <div class="form-item">
                  <div class="form-item-title">
                      营地总分
                  </div>

                  <div class="rate-text">
                      {{ totalRate }}
                  </div> 
              </div>

              
          </div>

          <!--营地设施信息-->
          <div class="camp-facility-info-wrap">
              <div class="section-title">营地设施信息</div>

              <template v-for="(facilityGroup, groupName) in groupedFacility" :key="groupName">
                  <!--设施组标题-->
                  <div class="sub-title">{{ groupName }} ({{ facilityGroup.length }})</div>

                  <!--设施选项-->
                  <template v-for="facility in facilityGroup" :key="facility.id">
                      <div class="form-item">
                          <div class="form-item-title">
                              <span v-if="facility.is_required" class="require-symbol">*</span>
                              {{ facility.title }}
                          </div>
                          <div class="form-element">
                              <t-select
                                v-model="formData.facility[facility.title]"
                                :options="facility.options.split(',').map(option => ({ label: option, value: option }))"
                                :multiple="facility.option_type === '2'"
                                filterable
                                clearable
                                placeholder="请选择"
                                size="large"
                              />
                              <div v-if="facility.is_desc" class="form-add">
                                  <t-input
                                    v-model="formData.facility[facility.title + '_desc']"
                                    placeholder="请输入补充说明"
                                    :maxlength="descMaxLength"
                                    show-limit-number
                                    clearable
                                    size="large"
                                  />
                              </div>
                          </div>
                      </div>
                  </template>
              </template>
          </div>    
      </t-form>
    </div>

    <action-bar 
        :confirm-text="'确定'"
        :cancel-text="'取消'"
        @confirm="submitForm"
        @cancel="handleCancel"
        :loading="submitting"
    />


</template>


<script setup>
    import { ref,reactive, onMounted,computed,watch  } from 'vue';
    import actionBar from '../../../components/action-bar/action-bar.vue';
    import campAPI from '../../../api/camp-api';
    import { MessagePlugin,DialogPlugin  } from 'tdesign-vue-next';
    import { useRouter } from 'vue-router';

    //获取 router 实例
    const router=useRouter();
    
    // 提交状态
    const submitting = ref(false);

    /**
     * 初始化表单字段
     */
    const formData = reactive({
        name: '',
        campType: [],
        location: '', 
        latitude: '', // 纬度字段
        longitude: '', // 经度字段
        openDate: [],
        openTime: ['09:00', '18:00'],
        price:'',
        priceDesc:'',
        phone:'',
        isOnSite: false,
        campTag: [],
        image: [],
        rate: '',
        envRate: '',
        facilityRate: '',
        experienceRate: '',
        facility: {}
    });

    // 初始化营地类型
    const campTypeOption = ref([]);
    // 初始化营地标签
    const campTag = ref([]);
    // 初始化营地设施
    const facilityList = ref([]);
    

    /**
     * 分隔经纬度函数
     */
    const handleLocation = (value) => {
        const [longitude, latitude] = value.split(',').map(coord => coord.trim());
        formData.longitude = longitude; // 经度
        formData.latitude = latitude;   // 纬度
    };
    
    watch(() => formData.location, (newValue) => {
        handleLocation(newValue); 
    });

    /**
    * 获取营地类型
    */
    const getCampType = async () => {
      try {
        const response = await campAPI.getCampType();
        campTypeOption.value = response.map(type => ({
          label: type.name,
          value: type.id
        }));
      } catch (error) {
        console.error('获取营地类型失败:', error);
        MessagePlugin.error('获取营地类型失败');
      }
    };

    // 获取营地标签
    const getCampTag = async () => {
        try {
          const response = await campAPI.getCampTag();
          campTag.value = response.map(tag => ({
            label: tag.name,
            value: tag.id
          }));
        } catch (error) {
          console.error('获取营地标签失败:', error);
          MessagePlugin.error('获取营地标签失败');
        }
    };

    /**
     * 获取营地设施选项
     */
    const getFacility = async () => {
        try {
            const allFacility = await campAPI.getFacility();
            // 查找启用状态的设施
            facilityList.value = allFacility.filter(f => f.is_active);

            // 初始化 formData.facility
            formData.facility = {};

            facilityList.value.forEach(facility => {
                // 设施选项
                if (facility.option_type === '2') { 
                    formData.facility[facility.title] = [];// 多选
                } else { 
                    formData.facility[facility.title] = '';// 单选
                }
                // 设施说明
                if (facility.is_desc) {
                    formData.facility[facility.title + '_desc'] = '';
                }
            });
        } catch (error) {
          console.error('获取设施失败:', error);
        }
    };

    /**
     * 计算按组名分组设施选项
     */
     const groupedFacility = computed(() => {
        const group = {};
            if (Array.isArray(facilityList.value) && facilityList.value.length > 0) {
                facilityList.value.forEach(facility => {
                  if (!group[facility.group_name]) {
                    group[facility.group_name] = [];
                  }
                  group[facility.group_name].push(facility);
                });
            }
        return group;
    });


    onMounted(async () => {
        try {
          await getCampType(); // 获取营地类型
          await getCampTag(); // 获取营地标签
          await getFacility(); // 获取设施数据
          console.log('设施数据:', facilityList.value);
        } catch (error) {
          console.error('初始化数据时发生错误:', error);
          MessagePlugin.error('初始化数据失败，请重试');
        }
    });

    /**
     * 计算营地总评分
     */
    const totalRate = computed(() => {
    const { envRate, facilityRate, experienceRate } = formData;
        if (envRate && facilityRate && experienceRate) {
          const total = (parseFloat(envRate) + parseFloat(facilityRate) + parseFloat(experienceRate)) / 3;
          return total.toFixed(1);
        }
        return '--';
    });

    watch([() => formData.envRate, () => formData.facilityRate, () => formData.experienceRate], 
      ([newEnvRate, newFacilityRate, newExperienceRate]) => {
        if (newEnvRate && newFacilityRate && newExperienceRate) {
          const total = (parseFloat(newEnvRate) + parseFloat(newFacilityRate) + parseFloat(newExperienceRate)) / 3;
          formData.rate = total.toFixed(1);
        } else {
          formData.rate = '';
        }
      }
    );


    /**
     * 上传图片
     */

    // 上传图片前验证
    const beforeUpload = (file) => {
        const isImage = file.type.startsWith('image/');
        const isSizeLimit = file.size / 1024 /1024 < 10;
        const allowedTypes = ['image/jpg','image/jpeg', 'image/png', 'image/gif', 'image/webp'];
        const isAllowedType = allowedTypes.includes(file.type);

        if (!isImage) {
            MessagePlugin.error('仅支持上传图片文件');
            return false;
        }
        if (!isAllowedType) {
            MessagePlugin.error('仅支持 JPG、PNG、GIF 和 WEBP 格式的图片');
            return false;
        }
        if (!isSizeLimit) {
          MessagePlugin.error('图片大小不能超过10MB');
          return false;
        } 
        return true;
    };

    // 上传图片成功处理
    const onUploadSuccess = (response, file) => {
        const imageUrl = response.url || file.url;
        if (imageUrl) {
            formData.image.push({ 
                url: imageUrl,
                raw: file.raw, 
                name: file.name,
            });
            MessagePlugin.success('图片上传成功');
        } else {
          console.error('无法获取上传图片的URL', response, file);
          MessagePlugin.error('图片上传失败，请重试');
        }
    };

    // 上传图片失败处理
    const onUploadFail = (response, file) => {
        console.error('图片上传失败:', response);
        MessagePlugin.error('图片上传失败，请重试');
    };


    /**
     * 提交表单事件
     */
    const submitForm = async () => {
        try {
            if (!validateForm()) { return; }
            const formDataToSend = new FormData();

            // 提交营地基础信息
            formDataToSend.append('name', formData.name.trim());
            formDataToSend.append('camp_type', JSON.stringify(formData.campType));
            // 修改价格处理逻辑，确保0也能正确提交
            formDataToSend.append('price', formData.price !== '' && formData.price !== null && formData.price !== undefined ? parseFloat(formData.price) : 0);
            formDataToSend.append('open_date', formData.openDate || '');
            formDataToSend.append('start_time', formData.openTime[0]);
            formDataToSend.append('end_time', formData.openTime[1]);
            formDataToSend.append('latitude', formData.latitude);
            formDataToSend.append('longitude', formData.longitude);
            formDataToSend.append('phone', formData.phone || '');
            // 处理价格说明的换行符
            const priceDesc = formData.priceDesc ? formData.priceDesc.replace(/\n/g, '\n') : '';
            formDataToSend.append('price_desc', priceDesc);
            formDataToSend.append('is_on_site', formData.isOnSite ? 'true' : 'false');
            formDataToSend.append('is_active', 'true');

            // 提交营地标签
            formDataToSend.append('camp_tag', JSON.stringify(formData.campTag));

            // 提交营地评分
            formDataToSend.append('base_rate', formData.rate);
            formDataToSend.append('base_env_rate', formData.envRate);
            formDataToSend.append('base_facility_rate', formData.facilityRate);
            formDataToSend.append('base_experience_rate', formData.experienceRate);

            // 提交营地图片
            if (formData.image && formData.image.length > 0) {
              formData.image.forEach((image, index) => {
                if (image.raw instanceof File) {
                  formDataToSend.append(`image`, image.raw, image.raw.name);
                }
              });
            } else {
                throw new Error('请上传至少一张图片');
            }

            // 提交营地设施
            const facilityData = [];
            for (const [title, value] of Object.entries(formData.facility)) {
                if (value) {
                    const facility = facilityList.value.find(f => f.title === title);
                        if (facility) {
                        facilityData.push({
                            facility_id: facility.id,
                            facility_name: facility.title,
                            facility_content: Array.isArray(value) ? value.join(',') : value,
                            facility_desc: formData.facility[title + '_desc'] || '',
                            facility_group: facility.group_name,
                            facility_group_id: facility.group_id,
                        });
                    }
                }
            }
            formDataToSend.append('facility', JSON.stringify(facilityData));

            console.log('提交数据:', formDataToSend);

          // 发送 API 请求
          const response = await campAPI.createCamp(formDataToSend);
          
          console.log('营地创建成功:', response);
          MessagePlugin.success('营地创建成功');

          // 重定向到营地管理页面
          router.push({
              path: '/camp/camp-admin',
              query: { refresh: 'true' } 
          });
          
        } catch (error) {
          console.error('营地创建失败:', error);
          MessagePlugin.error(`创建营地失败: ${error.message || '请重试'}`);
        }
    };


    /**
     * 验证表单
     */
    const validateForm = () => {
        if (!formData.name.trim()) {
            MessagePlugin.error('请输入营地名称');
            return false;
        }

        if (formData.campType.length === 0) {
            MessagePlugin.error('请选择营地类型');
            return false;
        }

        if (!formData.location.trim()) {
            MessagePlugin.error('请输入营地位置');
            return false;
        }

        if (formData.openDate.length === 0) {
            MessagePlugin.error('请选择开放日期');
            return false;
        }
        
        if (!formData.openTime[0] || !formData.openTime[1]) {
            MessagePlugin.error('请选择营业时间');
            return false;
        }

        if (formData.price === '' || formData.price === null || formData.price === undefined) {
            MessagePlugin.error('请输入营地价格');
            return false;
        }

        const price = parseFloat(formData.price);
        if (isNaN(price) || price < 0) { 
            MessagePlugin.error('营地价格不能为负数');
            return false;
        }

        if (price > 999999.99) {
            MessagePlugin.error('营地价格最大999999.99');
            return false;
        }

        if (formData.isOnSite === null || formData.isOnSite === undefined) {
            MessagePlugin.error('请选择是否进行实地认证');
            return false;
        }

        if (formData.image.length === 0) {
            MessagePlugin.error('请上传营地图片');
            return false;
        }

        if (formData.image.length > 30) {
            MessagePlugin.error('最多只能上传30张图片');
            return false;
        }

        // 验证评分
        const validateRate = (rate, name) => {
            if (!rate || isNaN(parseFloat(rate))) {
                MessagePlugin.error(`请输入${name}评分`);
                return false;
            }
            const rateValue = parseFloat(rate);
            if (rateValue < 0 || rateValue > 5) {
                MessagePlugin.error(`${name}评分必须在 0-5 之间`);
                return false;
            }
            return true;
        };

        if (!validateRate(formData.envRate, '环境') ||
            !validateRate(formData.facilityRate, '设施') ||
            !validateRate(formData.experienceRate, '体验')) {
            return false;
        }

        // 验证必填的设施信息
        for (const facility of facilityList.value) {
            if (facility.is_required) {
                const value = formData.facility[facility.title];
                if (!value || (Array.isArray(value) && value.length === 0)) {
                  MessagePlugin.error(`请选择${facility.title}`);
                  return false;
                }
            }
        }

      return true;
    };

    // 重置表单函数
    const resetForm = () => {
        Object.keys(formData).forEach(key => {
            if (Array.isArray(formData[key])) {
              formData[key] = [];
            } else if (typeof formData[key] === 'boolean') {
              formData[key] = false;
            } else {
              formData[key] = '';
            }
        });
    };

    /**
     * 取消处理
     */
    const handleCancel = () => {
        const dialog = DialogPlugin.confirm({
            header: '提示',
            body: '确定要取消添加营地吗？未保存的数据将会丢失。',
            confirmBtn: '确定',
            cancelBtn: '取消',
            width: 400,
            onConfirm: () => {
                dialog.destroy(); 
                router.push('/camp/camp-admin');
            },
            onCancel: () => {
                dialog.destroy(); 
            }
        });
    };

    // 图片尺寸限制
    const sizeLimit = ref({ size: 10, unit: 'MB' })

    // 开放日期选项
    const openDateOption=[
        { label: '全部', checkAll: true },
        { label: '周一', value: '1' },
        { label: '周二', value: '2' },
        { label: '周三', value: '3' },
        { label: '周四', value: '4' },
        { label: '周五', value: '5' },
        { label: '周六', value: '6' },
        { label: '周日', value: '7' },
    ]


    const openMapPicker=()=>{
      window.open('https://lbs.amap.com/tools/picker', '_blank');
    };

    const descMaxLength="200"

</script>

<style scoped >
    @import"./camp-add.css";
    @import"../../../components/style/style-content.css";
    @import"../../../components/style/style-add.css";
</style>